// import { Directive, Input } from '@angular/core';
// import { Validator, NG_VALIDATORS, AbstractControl } from '@angular/forms';

// @Directive({
//   selector: '[appHaConfirmPasswordGlobal]',
//   providers: [{
//     provide: NG_VALIDATORS,
//     useExisting: HaConfirmPasswordGlobalDirective,
//     multi: true
//   }]
// })
// export class HaConfirmPasswordGlobalDirective {

//   @Input() appHaConfirmPasswordGlobal: string;
//   validate(control: AbstractControl): { [key: string]: any } | null {
//     const controlToCompare = control.parent.get(this.appHaConfirmPasswordGlobal);
//     if (controlToCompare && controlToCompare.value !== control.value) {
//       return { 'notEqual': true };
//     }
//     return null;
//   }
//   constructor() { }

// }


import { Directive, forwardRef, Attribute } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
    selector: '[validateEqualll][formControlName],[validateEqualll][formControl],[validateEqualll][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => HaConfirmPasswordGlobalDirective), multi: true }
    ]
})
export class HaConfirmPasswordGlobalDirective implements Validator {
    constructor(@Attribute('validateEqualll') public validateEqualll: string,
    @Attribute('reverse') public reverse: string) {
    }

    private get isReverse() {
        if (!this.reverse) return false;
        return this.reverse === 'true' ? true: false;
    }

    validate(c: AbstractControl): { [key: string]: any } {
        // self value
        let v = c.value;

        // control vlaue
        let e = c.root.get(this.validateEqualll);

        // value not equal
        if (e && v !== e.value && !this.isReverse) {
            return {
                validateEqualll: false
            }
        }

        // value equal and reverse
        if (e && v === e.value && this.isReverse) {
            delete e.errors['validateEqualll'];
            if (!Object.keys(e.errors).length) e.setErrors(null);
        }

        // value not equal and reverse
        if (e && v !== e.value && this.isReverse) {
            e.setErrors({ validateEqualll: false });
        }

        return null;
    }
}
